var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("List Footage Estimate Gutter")]),_c('div',{staticClass:"card-body"},[_vm._v(" table ")])])
}]

export { render, staticRenderFns }